module.exports = __webpack_public_path__ + "img/printer-icon-white.38f7d77f.svg";